import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { SignUpComponent } from './sign-up/sign-up.component';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { UserService } from './services/user.service';
import { TermsComponent } from './terms/terms.component';
import { ScrollToDirective } from './directives/scroll-to.directive';
import { AppConfig } from './app-config/app.config';
import { ConfigurationProperties } from './models/configuration.properties';
import { WindowRefService } from './services/window-ref.service';
import { WindowService } from './services/window.service';
import { WebtrendsService } from './services/webtrends.service';
import { NG_SELECT_DEFAULT_CONFIG, NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { AnalyticService } from './services/analytic.service';
import { MixpanelService } from './services/mixpanel.service';
import { StoreAnalyticsService } from './services/store.analytics.service';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    SignUpComponent,
    TermsComponent,
    ScrollToDirective
  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgSelectModule,
    FormsModule,
    RouterModule.forRoot([
      {path: 'accounts', component: SignUpComponent},
      {path: 'terms-and-conditions', component: TermsComponent},
      {path: '', redirectTo: 'accounts', pathMatch: 'full'}
    ])
  ],
  providers: [
    UserService,
    WindowService,
    ConfigurationProperties,
    WindowRefService,
    WebtrendsService,
    MixpanelService,
    AnalyticService,
    StoreAnalyticsService,
    AppConfig,
    {
      provide: APP_INITIALIZER,
      useFactory: (config: AppConfig) => () => config.load(),
      deps: [AppConfig],
      multi: true
    },
    {
      provide: NG_SELECT_DEFAULT_CONFIG,
      useValue: {
        notFoundText: 'Does not match any role'
      }
    }
  ],
  bootstrap: [
    AppComponent
  ]
})
export class AppModule {
}
